export const UPPERCASE_WORDS = [
  'mrp',
  'rsp',
  'wsp',
  'uom',
  'pcs',
  'sku'
];